import { render } from "./DashboardShell.vue?vue&type=template&id=5a21ba70&scoped=true"
import script from "./DashboardShell.vue?vue&type=script&lang=js"
export * from "./DashboardShell.vue?vue&type=script&lang=js"

import "./DashboardShell.vue?vue&type=style&index=0&id=5a21ba70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a21ba70"]])

export default __exports__